













import { Component, Prop, Vue } from 'vue-property-decorator'
import Header from './templates/Header.vue'
import Footer from './templates/Footer.vue'
import Hero from './sections/Hero.vue'
import Showcase from './sections/Showcase.vue'
import Example from './sections/Example.vue'
import WhyUs from './sections/Why-us.vue'
import Testimony from './sections/Testimony.vue'
import Modals from '@/components/templates/Modal.vue'

@Component({
  components: {
    Header,
    Footer,
    Hero,
    Showcase,
    Example,
    WhyUs,
    Testimony,
    Modals
  }
})
export default class Landing extends Vue {
  @Prop() private msg!: string;
  mounted () {
    if (this.$route.query['section']) {
      if (this.$route.query['section'] === 'policy') {
        (document.getElementById('policyLink') as HTMLElement).click()
      } else if (this.$route.query['section'] === 'terms') {
        (document.getElementById('termsLink') as HTMLElement).click()
      } else {
        (document.getElementById('aboutUsLink') as HTMLElement).click()
      }
    }
  }
}
